import type { ModuleName } from '@contexts/modules-provider';
import type * as React from 'react';

import { InstructIllustration } from './components/illustrations/InstructIllustration';
import { ManageIllustration } from './components/illustrations/ManageIllustration';
import { TrainIllustration } from './components/illustrations/TrainIllustration';

export const MODULE_ILLUSTRATIONS: Record<ModuleName, React.ComponentType> = {
  Train: TrainIllustration,
  Manage: ManageIllustration,
  Instruct: InstructIllustration,
};
